<script>
export default {
  name: 'submenuPopup',
  props: {
    menu: Object,
    top: Number,
    actived: Boolean
  },
  render(h) {
    let childrenNode = []
    if (this.menu && this.menu.children && this.menu.children.length > 0) {
      this.menu.children.forEach(item => {
        let itemClass = ['ui-fold-submenu-popup-item']
        if(item.actived){
          itemClass.push('ui-fold-submenu-popup-item-actived')
        }
        childrenNode.push(
          h(
            'div',
            {
              class: itemClass,
              on: {
                click: () => {
                  console.log(item)
                  if(item.children&&item.children.length){
                    this.$store.commit('main/menus/setThirdMenus',item.children)
                    let thirdMenu = item.children[0]
                    this.$router.push({
                        path: thirdMenu.path,
                        query: {
                            id: thirdMenu.id
                        },
                        params: thirdMenu.params
                    })
                  }else{
                    this.$emit('on-click', { ...item, parentMenu: this.menu })
                  }
                }
              }
            },
            item.title
          )
        )
      })
    }

    return h(
      'div',
      {
        attrs: {
          class: 'ui-fold-submenu-popup'
        },
        style: {
          display: this.actived ? 'block' : 'none',
          top: this.top + 'px'
        }
      },
      childrenNode
    )
  },
  methods: {}
}
</script>
<style lang="stylus">
.ui-fold-submenu-popup
  position absolute
  transform translateY(-50%)
  font-size 14px
  background #27334f
  transition all 0.3s
  white-space nowrap
  box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)

  // &:before
  //   content ''
  //   position absolute
  //   top 50%
  //   transform translateY(-50%)
  //   left -16px
  //   width 0
  //   height 0
  //   border 8px solid transparent
  //   border-right 8px solid #fff

  &-item
    display flex
    align-items center
    cursor pointer
    // height 55px
    height 48px
    padding 0 32px
    // font-size 16px
    font-size 14px
    color #fff
    &:hover
      color #fff
      background #04cbd8
  &-item-actived
    background #04cbd8
</style>